// extracted by mini-css-extract-plugin
export default {"card":"index_card__D+0t9","buttons":"index_buttons__uk-QF"};